import { withInstall } from '@xzx-design/utils'
import _Image from './src/image'

export const Image = withInstall(_Image)
export default Image

export * from './src/image'
export * from './src/types'
